import * as yup from 'yup'

export const validationSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required('Primeiro nome é obrigatório')
    .test(
      'is-first-name-valid',
      'Por favor, insira apenas o primeiro nome',
      (value) => {
        if (!value) return false
        const firstName = value.trim().split(' ')[0]
        return firstName === value.trim()
      },
    ),
  email: yup
    .string()
    .email('E-mail inválido')
    .required('E-mail é obrigatório')
    .trim(),
})
